import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
  NgForm,
  Validators
} from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";
import { GeneralService } from "../services/general.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { Router } from "@angular/router";
import { MatDialog } from '@angular/material/dialog';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { DatePipe } from "@angular/common";

/** Error when invalid control is dirty, touched, or submitted. */

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: "app-addnewclient",
  templateUrl: "./addnewclient.component.html",
  styleUrls: ["./addnewclient.component.css"],
})
export class AddNewClientComponent implements OnInit {


  dataSource: any;

  modules: any[] = [];


  ClientForm: FormGroup; // New form group for the second form



  matcher = new MyErrorStateMatcher();

  displayedColumns: string[] = [
    "companyname",
    "email",
    "type",
    "expiredate",
    "action",
  ];
  data: object[] = [];
  clients: any;
  clientstofilter: any;
  editmode = false;
  clientid: any;
  currentuser: any;
  base64Image: any;
  clientlogo: any;
  packages: any;
  pakageReadOnly: boolean;
  countries = [{name:'Egypt'},{name:'Saudi Arabia'}];
  createddate: any;
  constructor(
    public GeneralService: GeneralService,
    private db: AngularFirestore,
    public router: Router,
    public dialog: MatDialog,
    private storage: AngularFireStorage,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.currentuser = JSON.parse(localStorage.getItem("currentuser"))
    var listid = [];
    const editmodules = JSON.parse(localStorage.getItem("modulesref"));
    const editdata = JSON.parse(localStorage.getItem("editobject"));
    const addmodules = JSON.parse(localStorage.getItem("addmodulesref"));
    const adddata = JSON.parse(localStorage.getItem("addobject"));
    const clientid = localStorage.getItem("addclientid");


    const databaseName=  localStorage.getItem('DbName')
    console.log(databaseName);


    if(editmodules && editdata){
      editmodules.forEach((id) => {
        listid.push({ id: this.db.firestore.doc("modules/" + id) });
      });
      editdata['moudlerf']= listid;
   this.editclient(editdata);
   localStorage.removeItem("modulesref");
   localStorage.removeItem("editobject");

    }

    if(addmodules && adddata && clientid){
      addmodules.forEach((id) => {
        listid.push({ id: this.db.firestore.doc("modules/" + id) });
      });
      adddata['moudlerf']= listid;
   this.addclientdefaultdb(adddata,clientid);
localStorage.removeItem("addmodulesref");
   localStorage.removeItem("addobject");
localStorage.removeItem("addclientid");


    }




    this.ClientForm = this.fb.group({
      database: ['', Validators.required],
      companyname: ['', Validators.required],
      username: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      address: ['', Validators.required],
      city: ['', Validators.required],
      country: ['', Validators.required],
      expiredate: ['', Validators.required],
      paid: ['', Validators.required],
      type: ['', Validators.required],
      phonenumber: ['', Validators.required],
      clientlogo: [null],
      package: ['', Validators.required],
      branches: ['', Validators.required],
      users: ['', Validators.required],
      audits: ['', Validators.required],
      module: [[], Validators.required],
    });
  

    this.retrievemodules();
    this.listofclients();
    this.getallclient();
    this.GetAllPackages();

  }
  getallclient() {
    this.GeneralService.getallClient().then(clients => {
      this.clients = clients;
      this.clientstofilter = clients
      console.log(this.clients)
    })
  }
  GetAllPackages() {
    this.GeneralService.getallPackage().then(res => {
      this.packages = res;
    })
  }


  getcatbypackage(element) {
    console.log(element);
      this.ClientForm.patchValue({
        branches: element.CountBranches,  
        users: element.CountUsers,
        audits: element.CountAudits
      });
      if (element.Name == "custom") {
        this.pakageReadOnly = false;
      }
      else {
        this.pakageReadOnly = true;
      }
    
 
  }


  removeclient(item) {
    this.GeneralService.removeclient(item);
    this.listofclients();
  }

  retrievemodules(): void {
    this.GeneralService
      .listofmodules()
      .then((data) => {
        this.modules = data;
        console.log(this.modules)
      });
  }

  applyFilter(event) {
    // this.clients.filter = filterValue.trim().toLowerCase();
    this.clients = this.clientstofilter.filter((ele: any) => {
      return ele.companyname.toLowerCase().includes(event.toLowerCase());
    });
  }
  onFileSelected(event) {
    let files = event.target.files;
    console.log(files);

    if (files && files.length > 0) {
      for (let file of files) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.base64Image = e.target.result;
          this.clientlogo = file
        };
        reader.readAsDataURL(file);
      }

    }

  }

  async uploadPhotos(photo: any, file: any): Promise<string[]> {
    var downloadUrls;
    if (photo) {
      console.log(file)

      const extension = this.getFileExtension(file.name);

      const photoPath = `ClientsLogo/_${new Date().getTime()}.${extension}`;
      const uploadTask = this.storage
        .ref(photoPath)
        .putString(photo, "data_url");
      await uploadTask.then(async (snapshot) => {
        const downloadUrl = await snapshot.ref.getDownloadURL();
        downloadUrls = downloadUrl;
      });

      return downloadUrls;
    }
    else {
      return null
    }

  }

 preventSpace(event: KeyboardEvent) {
    if (event.code === 'Space' || event.key === ' ') {
      event.preventDefault();
    }
  }

  private getFileExtension(fileName: string): string {
    return fileName.split('.').pop()?.toLowerCase() || 'jpg'; // Extract and normalize file extension
  }


 


  delete(element) {
    this.GeneralService.removeclient(element.id);
    this.getallclient();
  }
  listofclients() {
    // this.db.collection("cities").where("capital", "==", true)
    // .get()
    // .then(function(querySnapshot) {
    //     querySnapshot.forEach(function(doc) {
    //         // doc.data() is never undefined for query doc snapshots
    //         console.log(doc.id, " => ", doc.data());
    //     });
    // })
    // .catch(function(error) {
    //     console.log("Error getting documents: ", error);
    // });
    // this.GeneralService
    //   .listofclients().get()
    //   .pipe(
    //     map((changes) =>
    //       changes.map((c) => ({
    //         id: c.payload.doc.id,
    //         ...c.payload.doc.data()
    //       }))
    //     )
    //   )
    //   .subscribe((data) => {
    //     this.data = data;
    //     this.dataSource = new MatTableDataSource(this.data);
    //   });
  }

  addclient() {
console.log(this.ClientForm.value.module);
    return new Promise<any>(async (resolve, reject) => {
      let url = await this.uploadPhotos(this.base64Image, this.clientlogo);
      var listid = [];
      this.ClientForm.value.module.forEach((id) => {
        listid.push({ id: this.db.firestore.doc("modules/" + id) });
      });
      const selectedDate = new Date(this.ClientForm.value.expiredate);
      let data = {
        companyname: this.ClientForm.value.companyname,
        username: this.ClientForm.value.username,
        email: this.ClientForm.value.email,
        address: this.ClientForm.value.address,
        city: this.ClientForm.value.city,
        country: this.ClientForm.value.country,
        expiredate: selectedDate.getTime(),
        paid: this.ClientForm.value.paid,
        type: this.ClientForm.value.type,
        database: this.ClientForm.value.database,
        phonenumber: this.ClientForm.value.phonenumber,
        id: "",
        moudlerf: listid,
        clientlogo: url,
        role: "cluster",
        packageid: this.ClientForm.value.package,
        countusers: this.ClientForm.value.users,
        countbranches: this.ClientForm.value.branches,
        countaudits: this.ClientForm.value.audits,
        createdDate:Date.now()
      };
      localStorage.setItem("addobject",JSON.stringify(data));
      localStorage.setItem("addmodulesref",JSON.stringify(this.ClientForm.value.module));
      localStorage.setItem("DbName",this.ClientForm.value.database);

      const databaseName=  localStorage.getItem('DbName')
      console.log(databaseName);
  

      this.GeneralService.addclienttoanotherdb(data).then(res => {
        console.log(res);
        localStorage.setItem("addclientid",res.id);
        window.location.reload();

        resolve(res);
      }, error => {
        reject(error);
      }).catch(error => {
        console.error("API error:", error);
      });

    
    })











  }

  addclientdefaultdb(data,clientid){
    return new Promise<any>(async (resolve, reject) => {
      this.GeneralService.addclient(data,clientid).then(res => {
        this.getallclient();
        localStorage.removeItem("addmodulesref");
        localStorage.removeItem("addobject");
        localStorage.removeItem("addclientid");
        localStorage.removeItem("DbName");
        window.location.reload();

        resolve(res);
      }, error => {
        reject(error);
      }).catch(error => {
        // This block is executed if there is an error with the API call
        console.error("API error:", error);
        // Handle the error as needed, e.g., display an error message to the user
      });
    })
  }




  // executeClientOperations() {
  //   this.addclient()
  //     .then(result1 => {
  //       console.log('First operation completed:', result1);
  //       // return this.addclientdefaultdb();  // Return the promise from the second function
  //     })
  //     .then(result2 => {
  //       console.log('Second operation completed:', result2);
  //       window.location.reload();
  //     })
  //     .catch(error => {
  //       console.error('Error during client operations:', error);
  //     });
  // }

  
  gotoclient(el) {
    localStorage.removeItem("userid");
    localStorage.setItem('DbName',el.database);
    this.db.firestore['_databaseId'].database = el.database;

    this.router.navigateByUrl('/dashboard', { state: el.id });
  }
  editclient(client) {
    console.log(client);
    return new Promise<any>(async (resolve, reject) => {
      this.GeneralService.updateclient(client, client.id).then(res => {
        this.getallclient();
        localStorage.removeItem("editobject");
        localStorage.removeItem("modulesref");
        console.log("Edit client done");
        window.location.reload();
        resolve(res);
      }, error => {
        reject(error);
      }).catch(error => {
        alert(error);
      });
    });
  }
  
  editclientanotherdb() {
    return new Promise<any>(async (resolve, reject) => {
      let clientlogo;
      if (this.clientlogo) {
        let url = await this.uploadPhotos(this.base64Image, this.clientlogo);
        clientlogo = url;
      } else {
        clientlogo = this.ClientForm.value.clientlogo;
      }

      var listid = [];
      this.ClientForm.value.module.forEach((id) => {
        listid.push({ id: this.db.firestore.doc("modules/" + id) });
      });
  

      const selectedDate = new Date(this.ClientForm.value.expiredate);

      let data = {
        companyname: this.ClientForm.value.companyname,
        username: this.ClientForm.value.username,
        email: this.ClientForm.value.email,
        address: this.ClientForm.value.address,
        city: this.ClientForm.value.city,
        country: this.ClientForm.value.country,
        expiredate: selectedDate.getTime(),
        paid: this.ClientForm.value.paid,
        type: this.ClientForm.value.type,
        database: this.ClientForm.value.database,
        phonenumber: this.ClientForm.value.phonenumber,
        moudlerf: listid,
        clientlogo: clientlogo,
        role: "cluster",
        packageid: this.ClientForm.value.package,
        countusers: this.ClientForm.value.users,
        countbranches: this.ClientForm.value.branches,
        countaudits: this.ClientForm.value.audits,
      id:this.clientid,
      clientId:this.clientid,
      roles:"admin",
      createdDate:this.createddate
      };
    
        localStorage.setItem("editobject",JSON.stringify(data));
        localStorage.setItem("modulesref",JSON.stringify(this.ClientForm.value.module));

        this.GeneralService.updateclientanotherdb(data, this.clientid).then(res => {
        window.location.reload();
        resolve(res);
      }, error => {
        reject(error);
      }).catch(error => {
        alert(error);
      });
    });
  }
  

  edit(element) {
      this.editmode = true;
      this.createddate = element.createdDate;
      element.expiredate= this.datePipe.transform(element.expiredate, 'yyyy-MM-dd')!;
      this.ClientForm.patchValue({
        companyname: element.companyname,
        username: element.username,
        email: element.email,
        address: element.address,
        city: element.city,
        country: element.country,
        expiredate: element.expiredate,
        type: element.type,
        paid: element.paid,
        phonenumber: element.phonenumber,
        database: element.database,
        package: element.packageid,
        clientlogo: element.clientlogo,
        branches: element.countbranches,  
        users: element.countusers,
        audits: element.countaudits
      });
      const selectedModuleIds = Array.isArray(element.moudlerf) 
    ? element.moudlerf.map(mod => mod.id.id) 
    : [];
    this.ClientForm.get('module').setValue(selectedModuleIds);
      this.clientid = element.id;
  }

}
